import { API, graphqlOperation } from "aws-amplify";
import uuid from "uuid";

import * as mutations from '../../graphql/mutations';

import {
    UPDATE_CURRENT_APPLICATION_STATE
} from "../constants/action-types";

export async function saveEquipmentAppSync(items, grantApplication, user, funcs) {

    items.forEach((payload) => {
        if (!payload.id) {
            // This means that you are creating a new equipment
            let equipmentFilter = {
                input: {
                    grantApplicationEquipmentId: grantApplication.id,
                    name: payload.name,
                    femaItemNumber: payload.femaItemNumber,
                    federal: payload.federal || null,
                    county: payload.county || null,
                    countyInKind: payload.countyInKind || null,
                    deleted: payload.deleted,
                    updatedBy: user.username
                }
            }

            funcs.push(API.graphql(graphqlOperation(mutations.createEquipment, equipmentFilter)));
        } else {


            let same = false;
            for (let index = 0; index < grantApplication.equipment.items.length; index++) {
                const item = grantApplication.equipment.items[index];
                if ((item.id == payload.id) && (JSON.stringify(item) == JSON.stringify(payload))) {
                    same = true;
                    break;
                }
            }

            if(!same) {
                let equipmentFilter = {
                    input: {
                        grantApplicationEquipmentId: grantApplication.id,
                        id: payload.id,
                        name: payload.name,
                        femaItemNumber: payload.femaItemNumber,
                        federal: payload.federal || null,
                        county: payload.county || null,
                        countyInKind: payload.countyInKind || null,
                        deleted: payload.deleted,
                        updatedBy: user.username
                    }
                }
    
                funcs.push(API.graphql(graphqlOperation(mutations.updateEquipment, equipmentFilter)));
            }

        }
    })
}

export function saveEquipment(payload) {
    return async function (dispatch, getState) {


        const { grantApplication, currentApplicationState } = getState().rootReducer;
        if (!currentApplicationState.equipment.items) {
            currentApplicationState.equipment.items = [];
        }

        if (!payload.id && !payload.tempId) {
            payload.tempId = uuid.v4();
        }


        let arr = currentApplicationState.equipment.items, found = false;
        for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            if (item.tempId) {
                if (item.tempId == payload.tempId) {
                    currentApplicationState.equipment.items[i] = payload;
                    found = true;
                    break;
                }
            } else {
                if (item.id == payload.id) {
                    currentApplicationState.equipment.items[i] = payload;
                    found = true;
                    break;
                }
            }

        }

        if (!found) {
            currentApplicationState.equipment.items.push(payload)
        }

        dispatch({ type: UPDATE_CURRENT_APPLICATION_STATE, payload: JSON.parse(JSON.stringify(currentApplicationState)) });

    }
}
